const exVat = "ex. VAT"
const incVat = "inc. VAT"
const defaultVatType = "b2c"
const priceSelector = "span.vat_tax_price"

function checkNullUndefined(e) {
  return null != e;
}

function vatCreateCookie(e, t) {
  document.cookie = e + "=" + t + "" + "; path=/";
}

function vatReadCookie(e) {
  for (
    var t = e + "=", n = document.cookie.split(";"), a = 0; a < n.length; a++
  ) {
    for (var c = n[a];
      " " == c.charAt(0);) c = c.substring(1, c.length);
    if (0 == c.indexOf(t)) return c.substring(t.length, c.length);
  }
  return null;
}

function vatEraseCookie(e) {
  vatCreateCookie(e, "", -1);
}

function changeAllHelper(e) {
  document.querySelectorAll(".vat-inc-ex").forEach(function (t) {
    t.innerHTML = " (" + e + ")";
  });
}

function formatMoney(total) {
  if (typeof total === "string") {
    total = total.replace(".", "");
  }

  total = (total / 100.0).toFixed(2);

  const parts = total.split(".");
  const poundsAmount = parts[0].replace(
    /(\d)(?=(\d\d\d)+(?!\d))/g,
    `$1,`
  );
  const penniesAmount = parts[1] ? "." + parts[1] : "";

  return poundsAmount + penniesAmount;
}

function getPrice(e, t) {
  var a = t.replace(/[^0-9]/g, "");
  var c = t
    .replace(/[0-9]/, "__")
    .replace(/\d+([,.]\d+)?/g, "")
    .replace(/,/g, "")
    .replace(/\./g, "");
  if (e == "b2b") {
    var b = ((100 * parseInt(a)) / (100 + parseFloat(20))).toFixed(0);
  } else {
    var b = (parseInt(a) + parseInt(a * 20) / 100).toFixed(0);
  }
  var f = b;
  var d = c.replace("__", f);
  f = formatMoney(d);
  return f;
}

function initPrices(n) {
  document
    .querySelectorAll(priceSelector)
    .forEach(function (t) {
      let priceHelper = t.nextElementSibling;
      if (priceHelper !== null) {
        if (!priceHelper.classList.contains("vat-inc-ex")) {
          if (!t.classList.contains("vat-inc-ex")) {
            if (t.className !== 'unit-price') {
              var el = document.createElement("span");
              el.classList.add("vat-inc-ex");
              t.parentNode.insertBefore(el, t.nextSibling);
            }
          }
        }
      } else {
        if (!t.classList.contains("vat-inc-ex")) {
          if (t.className !== 'unit-price') {
            var el = document.createElement("span");
            el.classList.add("vat-inc-ex");
            t.parentNode.insertBefore(el, t.nextSibling);
          }
        }
      }
      if (!t.hasAttribute("data-b2b") || !t.hasAttribute("data-b2c")) {
        var innerHtmlValue = t.innerHTML.trim();
        var filteredPrice = innerHtmlValue;
        filteredPrice = filteredPrice.replace(/\D/g, "");
        var finalPrice = filteredPrice;
        var originalPrice = finalPrice;
        originalPrice = formatMoney(originalPrice);

        if (n === "b2c") {
          t.setAttribute("data-b2b", getPrice("b2b", finalPrice)),
            t.setAttribute("data-b2c", originalPrice);
        } else {
          t.setAttribute("data-b2c", getPrice("b2c", finalPrice)),
            t.setAttribute("data-b2b", originalPrice);
        }
      }
    });
}

function changePrices(e) {
  document
    .querySelectorAll(priceSelector)
    .forEach(function (t) {
      t.getAttribute("data-pricing");
      t.setAttribute("data-pricing", e);
      var n = t.getAttribute("data-" + e);
      t.innerHTML = "£" + n;
    });
}

function vatToggleChangeAll(e) {
  if (void 0 === e) {
    var n = defaultVatType;
    initPrices(n);
  } else {
    changePrices((n = e));
  }
  changeAllHelper("b2b" === n ? exVat : incVat);
  setHeaderTax(n)
}

function vatToggleInit() {
  vatToggleChangeAll();
  var t = vatReadCookie("vatType");
  if (t == null) {
    vatEraseCookie("vatType");
    vatCreateCookie(
      "vatType",
      defaultVatType
    );
    vatToggleChangeAll(defaultVatType);
  } else {
    vatToggleChangeAll(t);
  }
}

function setHeaderTax(value) {
  document.querySelectorAll(".vat-toggle-switch-label").forEach(function (e) {
    e.innerHTML = "b2b" === value ? "Ex. VAT" : "Inc. VAT";
  });
}

if (document.querySelector(".vat-toggle-inline") !== null) {
  const b2bCookie = vatReadCookie("vatType") == "b2b";

  document.querySelectorAll(".vat-toggle-inline").forEach(function (e) {
    e.innerHTML = `<input type="checkbox" class="vat-toggle-switch" id="vat-toggle-switch" ${b2bCookie ? "" : "checked"}><label class="vat-toggle-switch-label" for="vat-toggle-switch"></label>`;
  });
}

document.querySelectorAll(".vat-toggle-switch").forEach(function (e) {
  e.addEventListener("change", function (t) {
    const vatType = this.checked ? "b2c" : "b2b"

    vatEraseCookie("vatType");
    vatCreateCookie(
      "vatType",
      vatType
    );
    vatToggleChangeAll(vatType);
    setHeaderTax(vatType)
  });
});

document.addEventListener("DOMContentLoaded", function (e) {
  vatToggleInit()
});

document.addEventListener("on:variant:change", function (e) {
  vatToggleInit()
});

var taxSelectorobserver = new MutationObserver(function (
  mutationsList,
  taxSelectorobserver
) {
  var vatInit = false;
  var vatMutation = false;
  mutationsList.forEach(function (m) {
    if (m.type === "childList") {
      var checkPriceElement = m.target.querySelectorAll(
        priceSelector
      );
      if (checkPriceElement !== null) {
        checkPriceElement.forEach((el) => {
          if (vatInit === false) {
            var newData = el.textContent,
              b2cPrice = el.dataset.b2c,
              b2bPrice = el.dataset.b2b,
              vatType = el.dataset.pricing,
              formattedNewData =
                newData !== undefined ?
                  newData.replace(/[^0-9a-zA-Z.]/g, "") :
                  "",
              formattedB2cPricing =
                b2cPrice !== undefined ?
                  b2cPrice.replace(/[^0-9a-zA-Z.]/g, "") :
                  "",
              formattedB2bPricing =
                b2bPrice !== undefined ?
                  b2bPrice.replace(/[^0-9a-zA-Z.]/g, "") :
                  "";
            if (
              vatType === undefined ||
              formattedB2bPricing === undefined ||
              formattedB2cPricing === undefined ||
              formattedNewData === undefined
            ) {
              vatMutation = true;
              vatInit = true;
              setTimeout(vatToggleInit, 100);
              taxSelectorobserver.disconnect();
              setTimeout(function () {
                taxSelectorobserver.observe(document.querySelector("body"), {
                  characterData: false,
                  childList: true,
                  attributes: false,
                  subtree: true,
                });
              }, 500);
            } else {
              if (
                vatType === "b2b" &&
                formattedB2bPricing !== formattedNewData
              ) {
                vatMutation = true;
                vatInit = true;
                taxSelectorobserver.disconnect();
                setTimeout(vatToggleInit, 100);
                setTimeout(function () {
                  taxSelectorobserver.observe(
                    document.querySelector("body"), {
                    characterData: false,
                    childList: true,
                    attributes: false,
                    subtree: true,
                  }
                  );
                }, 500);
              } else if (
                vatType === "b2c" &&
                formattedB2cPricing !== formattedNewData
              ) {
                vatMutation = true;
                vatInit = true;
                taxSelectorobserver.disconnect();
                setTimeout(vatToggleInit, 100);
                setTimeout(function () {
                  taxSelectorobserver.observe(
                    document.querySelector("body"), {
                    characterData: false,
                    childList: true,
                    attributes: false,
                    subtree: true,
                  }
                  );
                }, 500);
              }
            }
          }
        });
      }
    }
  });
});

if (window.vatToggle.currentProduct !== undefined) {
  window.addEventListener("load", (event) => {
    setTimeout(function () {
      taxSelectorobserver.observe(document.querySelector("body"), {
        characterData: false,
        childList: true,
        attributes: false,
        subtree: true,
      });
    }, 500);
  });
}